export const ACCESS_WINDOW_DAYS = 365;
/** Downloads unlock this many days before the window ends. */
export const DOWNLOAD_UNLOCK_DAYS = 30;
/** A paid renewal always adds a complete year without discarding owned time. */
export function renewedAccessExpiryMs(existingExpiryMs, nowMs = Date.now()) {
    return Math.max(existingExpiryMs ?? 0, nowMs) + ACCESS_WINDOW_DAYS * 24 * 60 * 60 * 1000;
}
/** A paid grant must never leave a shorter gift/trial window in force. */
export function minimumPaidAccessExpiryMs(existingExpiryMs, nowMs = Date.now()) {
    return Math.max(existingExpiryMs ?? 0, nowMs + ACCESS_WINDOW_DAYS * 24 * 60 * 60 * 1000);
}
/**
 * Mirrors the callable's exact boundary semantics for viewer presentation.
 * A recital-grant override changes only the opening instant; the account-wide
 * access expiry remains the hard end of the download window.
 */
export function getDownloadWindow(accessExpiresAt, now = new Date(), downloadsUnlockAt) {
    const accessEndDate = new Date(accessExpiresAt);
    const standardUnlockMs = accessEndDate.getTime() - DOWNLOAD_UNLOCK_DAYS * 24 * 60 * 60 * 1000;
    const overrideUnlockMs = downloadsUnlockAt ? Date.parse(downloadsUnlockAt) : Number.NaN;
    const unlockDate = new Date(Number.isFinite(overrideUnlockMs)
        ? Math.min(overrideUnlockMs, standardUnlockMs)
        : standardUnlockMs);
    const nowMs = now.getTime();
    const status = nowMs >= accessEndDate.getTime()
        ? "expired"
        : nowMs >= unlockDate.getTime()
            ? "unlocked"
            : "locked";
    return { status, unlockDate, accessEndDate };
}
export const DEVICE_LIMIT = 3;
/** Replacement-device activations available per product calendar month. */
export const DEVICE_SWAPS_PER_MONTH = 3;
export const WEB_DEVICE_IDLE_EXPIRY_DAYS = 30;
export const WEB_DEVICE_IDLE_EXPIRY_MS = WEB_DEVICE_IDLE_EXPIRY_DAYS * 24 * 60 * 60 * 1000;
/** Web slots expire only after the complete idle window has elapsed. */
export function isExpiredWebDevice(device, now = Date.now()) {
    if (device.platform !== "web")
        return false;
    const lastUsedAtMs = Date.parse(device.lastUsedAt);
    const nowMs = typeof now === "number" ? now : now.getTime();
    return (Number.isFinite(lastUsedAtMs) &&
        Number.isFinite(nowMs) &&
        lastUsedAtMs < nowMs - WEB_DEVICE_IDLE_EXPIRY_MS);
}
/** Counts unique watched dances that still belong to each performance's actual program. */
export function countWatchedDancesByPerformance(performances) {
    return performances.reduce((total, performance) => {
        const actualDanceIds = new Set(performance.danceIds);
        const watched = new Set(performance.watchedDanceIds ?? []);
        const matching = [...watched].filter((danceId) => actualDanceIds.has(danceId)).length;
        return total + Math.min(performance.danceCount ?? actualDanceIds.size, matching);
    }, 0);
}
